import client from '../config/AxiosConfig';

export const CreateWeddingCanvaTemplate = async (data) =>
  client.post(`/weddingCanvaTemplate`, data);

export const UpdateWeddingCanvaTemplate = async (id, data) =>
  client.put(`/weddingCanvaTemplate/${id}`, data);

export const GetWeddingCanvaTemplates = async (currentPage, limit, filters = {}) =>
  client.get(`/weddingCanvaTemplate/${currentPage}/${limit}?filter=${JSON.stringify(filters)}`);

export const SoftDeleteWeddingCanvaTemplate = async id =>
  client.put(`/weddingCanvaTemplate/softDelete/${id}`);

export const GetAllWeddingCanvaTemplates = async (filters = {}) =>
  client.get(`/weddingCanvaTemplate/all?filter=${JSON.stringify(filters)}`);